
import Component, { mixins } from 'vue-class-component'
import NewsMixin from './news-mixin/index'
import ItemTitle from '@/components/item-title/index.vue'
@Component({
  components: {
    ItemTitle
  }
})

export default class Index extends mixins(NewsMixin) {}
